/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FormEvent, useState } from "react";
import { DA_Button } from "@danishagro/shared/src/components/atoms/Button/Button.component";
import { DA_Input } from "@danishagro/shared/src/components/atoms/Input/Input.component";
import { DA_Select } from "@danishagro/shared/src/components/atoms/Select/Select.component";
import { DA_Spinner } from "@danishagro/shared/src/components/atoms/Spinner/Spinner.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import { DA_Title } from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { DA_InputWrapper } from "@danishagro/shared/src/components/atoms/InputWrapper/InputWrapper.component";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { useFormValidation } from "./hooks/useFormValidation";
import S from "./SupplierService.module.scss";

export const SupplierService = () => {
    const { getDictionaryString } = useTranslations();
    const [viewState, setViewState] = useState<string>("NONE");

    const { cvrAndCustomerNumbers } = useAppData();
    const isAuthenticated = globalThis.isAuthenticated;

    // Assuming cvrAndCustomerNumbers is structured as provided and properly assigned
    const newCustomerNumbers = cvrAndCustomerNumbers?.accounts?.reduce((acc: string[], account) => {
        const customerNumbers = account?.customers?.map((customer) => customer?.number);
        return acc.concat(customerNumbers);
    }, []);

    //RedirectURL
    const REDIRECT_URL_SIGNUP = `https://tilmeld.leverandoerservice.dk/DOB/LS?id=-1803361592&pbs=1ad63ca01b554e849c4dbb7e9e4cd2a9&kundenrLabel=Kundenr.&cvr=&dbnr=`;

    //Validation hook
    const { validationErrorMessages, validate, onInputChange } = useFormValidation();

    const onFormSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const body = {} as any;

        const form = new FormData(event.target as HTMLFormElement);
        form.forEach((value, key) => (body[key] = value));

        const [isValidCustomer] = await validate(body);

        if (isValidCustomer) {
            setViewState("LOADING");
            // Redirect to page with the customer number
            const redirectLink = `${REDIRECT_URL_SIGNUP}${body.customerNumber}&knmin=&knmax=`;
            window.location.href = redirectLink;
        }
    };

    //Errors
    const customerNumberError = validationErrorMessages.find((x) => x.key === "customerNumber");
    return (
        <div className={S.supplierService}>
            <DA_Title h2 noMargin>
                {getDictionaryString("SupplierService.Headline")}
            </DA_Title>
            <DA_Text html={getDictionaryString("SupplierService.NetsSignup")} noPadding />

            {viewState === "LOADING" ? (
                <DA_Spinner className={S.spinner} />
            ) : (
                <form noValidate onSubmit={onFormSubmit} className={S.form}>
                    {isAuthenticated ? (
                        // User is logged in, show dropdown
                        <>
                            {viewState === "LOADING" ? (
                                <DA_Spinner className={S.spinner} />
                            ) : (
                                <DA_InputWrapper
                                    invalid={customerNumberError ? true : false}
                                    helperText={
                                        customerNumberError ? customerNumberError.value : undefined
                                    }
                                >
                                    <DA_Select
                                        id="customerNumber"
                                        name="customerNumber"
                                        placeholder={getDictionaryString(
                                            "SupplierService.SelectPlaceholder"
                                        )}
                                        onChange={() => onInputChange("customerNumber")}
                                        invalid={customerNumberError ? true : false}
                                        options={[
                                            ...(newCustomerNumbers?.map((option) => ({
                                                value: option,
                                                label: option,
                                            })) || []),
                                        ]}
                                        className={S.select}
                                    />
                                </DA_InputWrapper>
                            )}
                        </>
                    ) : (
                        // User is not logged in, show input field
                        <DA_Input
                            id="customerNumber"
                            name="customerNumber"
                            type="number"
                            placeholder={getDictionaryString("SupplierService.InputPlaceholder")}
                            invalid={customerNumberError ? true : false}
                            label={`${getDictionaryString("SupplierService.CustomerNumberLabel")}`}
                            onChange={() => onInputChange("customerNumber")}
                            disabled={viewState === "LOADING"}
                            helperText={customerNumberError ? customerNumberError.value : undefined}
                            autoComplete="off"
                        />
                    )}
                    <div>
                        <DA_Button
                            title={getDictionaryString("SupplierService.Continue")}
                            disabled={viewState === "LOADING"}
                            submit
                            showSpinner={viewState === "LOADING"}
                        />
                    </div>
                </form>
            )}
        </div>
    );
};
